var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gw-category"},[_c('div',{staticClass:"gw-category__gem"}),_vm._v(" "),_c('span',{staticClass:"gw-category__text"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }